// @flow

import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import FormLayout from '@/layouts/FormLayout'
import { Title, Back, Copy } from '@/components/Form'
import slugify from 'slugify'

type Props = {
  data: Object,
  pageContext: Object,
}

function FormPageTemplate({
  pageContext: { section },
  data: {
    page: {
      data: {
        title: { text: title },
        description: { html: description },
        action: { url: action },
        form,
      },
    },
	settings
  },
}: Props) {
  const Form = require(`../forms/${slugify(
    form.toLocaleLowerCase()
  )}.js`).default

  useEffect(() => {
    document.title = 'Arcadia.org' + (title ? " | " + title : "")
  }, []);
  const generic_title = "Request a Complimentary Brochure"
  const generic_desc = "Learn more about our programs and services by selecting a brochure from the list or email us at <strong><a href='mailto:info@arcadia.org'>info@arcadia.org</a></strong>."
  const display_title = title.toLowerCase().includes('tour') ? title : generic_title
  const display_desc  = title.toLowerCase().includes('tour') ? description : generic_desc

  return (
    <FormLayout section={section}
	  logoSrc={settings.data.company_logo.url}
      logoAlt={settings.data.company_logo.alt}>
      <div>
        <Back>← Back</Back>
        <Title>{display_title}</Title>
        <Copy dangerouslySetInnerHTML={{ __html: display_desc }} />
      </div>
      {typeof window !== 'undefined' && (
        <Form
          action={
            section
              ? action?.replace(
                  `${slugify(section.toLowerCase())}-`,
                  `${slugify(section.toLowerCase())}/`
                )
              : action
          }
        />
      )}
    </FormLayout>
  )
}

export default FormPageTemplate

export const query = graphql`
  query ($uid: String!) {
    page: prismicForm(uid: { eq: $uid }) {
      data {
        title: form_title {
          text
        }
        description {
          html
        }
        action: form_submitted {
          url
        }
        form
        metaTitle: meta_title
        metaDescription: meta_description {
          text
        }
      }
    }
	settings: prismicGlobalSettings {
      ...LogoSettings
    }
  }
`
